import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import Spinner from '../spinner'
import { ButtonContained, ButtonOutlined } from '../app-button/button'
import { required } from './validation/validation'
import renderSelectField from './field/customSelect'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'
import { DeliteIcon } from '../app-icon/Icons'

const styles = theme => ({
  form: {
    maxWidth: 340,
    width: '100%',
  },
  chip: {
    width: '100%',
    marginBottom: 16,
  },
  root: {
    paddingLeft: 21,
    paddingRight: 3,
    borderRadius: 4,
    height: 48,
    justifyContent: 'flex-start',
  },
  colorSecondary: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  deleteIcon: {
    color: '#000',
    marginLeft: 'auto',
    '&:hover': {
      color: '#000',
    },
  },
  label: {
    paddingLeft: 0,
  },
  fieldGroupe: {
    display: 'flex',
  },
  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  '@keyframes wiggle2': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
})

class YandexMarketChanelForm extends Component {
  state = {}

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  handleDelete = () => {
    location.href = this.props.dataSource.deleteUrl // eslint-disable-line no-alert
  }

  redirect = (url, status) => {
    if (status === 'ok') {
      location.href = url
    }
  }

  render() {
    const {
      classes,
      handleSubmit,
      isFetching,
      submitFailed,
      invalid,
      dataSource,
    } = this.props

    const campaigns = () => {
      if (!dataSource) {
        return
      }

      const list = dataSource.campaigns.map(campaign => {
        return (
          <MenuItem value={campaign.id} key={campaign.id}>
            {campaign.name}
          </MenuItem>
        )
      })

      return list
    }

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <Chip
          label={dataSource.accountName}
          onDelete={dataSource.status === 'inactive' ? this.handleDelete : null}
          className={classes.chip}
          variant="outlined"
          color="secondary"
          classes={{
            root: classes.root,
            label: classes.label,
            colorSecondary: classes.colorSecondary,
            deleteIconOutlinedColorSecondary: classes.deleteIcon,
          }}
        />

        {!dataSource.hasAuthError ? (
          <div>
            <Field
              name="campaign"
              component={renderSelectField}
              validate={[required]}
            >
              <MenuItem value="" style={{ display: 'none' }}>
                <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                  Выберите магазин
                </span>
              </MenuItem>
              {campaigns()}
            </Field>

            <Typography
              variant="subtitle1"
              component="div"
              style={{
                marginBottom: 8,
                padding: '6px 13px 6px',
                backgroundColor: 'rgba(255, 204, 0, .2)',
              }}
            >
              <strong>Обратите внимание:</strong>
              данные о расходах из этого канала передаются с уже включённым НДС
            </Typography>
          </div>
        ) : (
          <Typography
            variant="subtitle1"
            component="div"
            style={{
              marginBottom: 8,
              padding: '6px 13px 6px',
              backgroundColor: 'rgba(255, 59, 48, 0.1)',
            }}
          >
            Ошибка авторизации. Для корректной работы необходимо удалить канал и подключить его заново.
          </Typography>
        )}

        {dataSource.status === 'active' ? (
          <div style={{ marginTop: 16, display: 'flex' }}>
            {!dataSource.hasAuthError ? (
              <ButtonContained
                style={{
                  flexShrink: 0,
                  fontSize: 16,
                  width: 139,
                  height: 48,
                  padding: 0,
                  marginRight: 16,
                  fontWeight: 700,
                  color: '#fff',
                }}
                type="submit"
                color="secondary"
                text={isFetching ? <Spinner /> : 'Сохранить'}
                onClick={() => this.handleClick(classes, submitFailed)}
              />
            ) : null}

            <ButtonOutlined
              handleClick={this.handleDelete}
              style={{
                maxWidth: !dataSource.hasAuthError ? 280 : '100%',
                width: '100%',
                padding: 0,
                height: 48,
              }}
              color="secondary"
              text={'Удалить канал'}
            />
          </div>
        ) : (
          <ButtonContained
            style={{
              height: 48,
              fontSize: 16,
              width: '100%',
              padding: 0,
              fontWeight: 700,
              color: '#fff',
            }}
            type="submit"
            color="secondary"
            text={isFetching ? <Spinner /> : 'Добавить канал'}
            onClick={() => this.handleClick(classes, submitFailed)}
          />
        )}
      </form>
    )
  }
}

YandexMarketChanelForm = reduxForm({
  form: 'YandexMarketChanelForm',
})(YandexMarketChanelForm)

export default withStyles(styles)(YandexMarketChanelForm)
